import { createReducer, INITIAL_STATE } from '@shared/redux';

export const CLOSE_CARD_MODAL_WITH_TIMEOUT = '@card/interface/CLOSE_CARD_MODAL_WITH_TIMEOUT';
export const CLOSE_CARD_SELECTED_MODAL = '@card/interface/CLOSE_CARD_SELECTED_MODAL';
export const OPEN_CARD_SELECTED_MODAL = '@card/interface/OPEN_CARD_SELECTED_MODAL';
export const TOGGLE_ADJUST_PAGE = '@card/interface/TOGGLE_ADJUST_PAGE';
export const ACTIVE_PROGRESS_BAR_ANIMATION = '@card/interface/ACTIVE_PROGRESS_BAR_ANIMATION';
export const CHANGE_SMART_FUNNEL_STEP = '@card/interface/CHANGE_SMART_FUNNEL_STEP';
export const SET_AUTOMATION_LOADING = '@card/interface/SET_AUTOMATION_LOADING';
export const RESET_INTERFACE_STATE = '@card/interface/RESET_INTERFACE_STATE';
export const VALIDATE_MODAL = '@card/selected-card/VALIDATE_MODAL';
export const APPLY_CARD = '@card/interface/APPLY_CARD';
export const APPLY_AUTOMATIC_CARD = '@card/interface/APPLY_AUTOMATIC_CARD';
export const UPDATE_WORKFLOW_CARD = '@card/interface/UPDATE_WORKFLOW_CARD';

export const isAdjustPageOpen = state => state.cards.cardSelected.isAdjustPageOpen;
export const isModalOpen = state => state.cards.interface.isModalOpen;
export const isProgressBarAnimationActive = state => state.cards
    .interface.isProgressBarAnimationActive;
export const getSmartFunnelStep = state => state.cards.interface.getSmartFunnelStep;
export const isAutomationLoading = state => state.cards.interface.isAutomationLoading;
export const isModalValid = state => state.cards.cardSelected.isModalValid;

export const updateWorkflowCard = () => ({
    type: UPDATE_WORKFLOW_CARD,
    payload: {},
});

export const closeCardModalWithTimeout = () => ({
    type: CLOSE_CARD_MODAL_WITH_TIMEOUT,
    payload: {},
});

export const closeCardModal = () => ({
    type: CLOSE_CARD_SELECTED_MODAL,
    payload: {},
});

export const openCardModal = () => ({
    type: OPEN_CARD_SELECTED_MODAL,
    payload: {},
});

export const toggleAdjustPage = () => ({
    type: TOGGLE_ADJUST_PAGE,
    payload: {},
});

export const activeProgressBarAnimation = () => ({
    type: ACTIVE_PROGRESS_BAR_ANIMATION,
    payload: {},
});

export const changeSmartFunnelStep = funnelStep => ({
    type: CHANGE_SMART_FUNNEL_STEP,
    payload: { funnelStep },
});

export const setAutomationLoading = () => ({
    type: SET_AUTOMATION_LOADING,
    payload: {},
});

export const resetCardInterfaceState = () => ({
    type: RESET_INTERFACE_STATE,
    payload: {},
});

export const validateModal = value => ({
    type: VALIDATE_MODAL,
    payload: {
        isModalValid: value,
    },
});

export const applyCard = card => ({
    type: APPLY_CARD,
    payload: { card },
});

export const applyAutomaticCard = card => ({
    type: APPLY_AUTOMATIC_CARD,
    payload: { card },
});
const initialState = {
    isModalOpen: false,
    isDismissOpen: false,
    isAdjustPageOpen: false,
    isProgressBarAnimationActive: false,
    smartFunnelStep: 0,
    isAutomationLoading: false,
};

export const cardInterfaceReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [RESET_INTERFACE_STATE]: () => initialState,
    [CLOSE_CARD_SELECTED_MODAL]: state => ({
        ...state,
        isModalOpen: false,
    }),
    [OPEN_CARD_SELECTED_MODAL]: state => ({
        ...state,
        isModalOpen: true,
    }),
    [TOGGLE_ADJUST_PAGE]: state => ({
        ...state,
        isAdjustPageOpen: !state.isAdjustPageOpen,
    }),
    [ACTIVE_PROGRESS_BAR_ANIMATION]: state => ({
        ...state,
        isProgressBarAnimationActive: true,
    }),
    [CHANGE_SMART_FUNNEL_STEP]: (state, action) => ({
        ...state,
        smartFunnelStep: action.payload.funnelStep,
    }),
    [SET_AUTOMATION_LOADING]: state => ({
        ...state,
        isAutomationLoading: true,
    }),
    [VALIDATE_MODAL]: (state, action) => ({
        ...state,
        isModalValid: action.payload.isModalValid,
    }),
});
